/**
 * 应用运行组件
 * zxw
 * 创建时间 2026-01-30
 */

import CNF from '../../incs/Config';
import {
    winHeight,
    AddRequestHeaders,
    GetObjValueByPath,
    UjoinParams,
} from '../../incs/FunHelper';
import cookie from 'react-cookies';
import { StopIcon } from "../../incs/Icons";
import $ from 'jquery';
import { useState, useEffect, useRef } from 'react';
import {
    Flex,
    theme,
    Button,
    Space,
    Avatar,
    Typography,
    Statistic,
    Badge,
    message,
    Tooltip,
} from 'antd';
import {
    SettingOutlined,
    ContainerOutlined,
    ClearOutlined,
    CaretRightOutlined,
    SyncOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    ArrowUpOutlined,
} from '@ant-design/icons';
import {
    Sender,
    Prompts,
    Bubble,
} from '@ant-design/x';
import {
    useXChat,
} from '@ant-design/x-sdk';

// 自定义数据提供
import StepEntity from "./StepEntity";

const { Title, Paragraph, Text } = Typography;


const AppRun = (props) => {
    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            colorStepBg,
            colorTextBase,
            colorBgSolid,
            colorBasePlaceholder,
            colorSuccessActive,
            colorErrorActive,
            fontSizeLG,
            fontSizeSM,

        },
    } = theme.useToken();

    const [messageApi, contextHolder] = message.useMessage();

    const [appInfo, setAppInfo] = useState(null);
    const [appNodeData, setAppNodeData] = useState([]);

    /** AI请求部分 **/
    const contentRef = useRef(null);
    const [runStatus, setRunStatus] = useState(false);
    const [content, setContent] = useState('');         //  用户当前输入内容
    /** AI请求部分 **/

    // 初始化应用信息
    useEffect(() => {
        const getAppInfo = () => {
            const params = {
                'rss': 'info',
                'app_id': props.appId,
            };
            $.ajax({
                url: `${CNF.api}app/infos${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
            })
                .done(function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            const appConfigJson = JSON.parse(data.dat[0].app_config);
                            // 获取节点数据
                            let appNodeData = new Array();
                            for (let i = 0; i < appConfigJson.cells.length; i++) {
                                let node = appConfigJson.cells[i];
                                if (node.shape === 'app-drop-node') {
                                    let obj = node.data;
                                    delete obj.icon;        // 删除图标
                                    delete obj.isSelected;  // 删除选中状态
                                    obj['runTime'] = 0;     // 初始化运行时间，单位毫秒
                                    appNodeData[node.zIndex] = obj;
                                }
                            }
                            setAppNodeData(appNodeData);
                            setAppInfo(data.dat[0]);

                        } else {
                            setAppNodeData(null);
                            setAppInfo(null);
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                })
                .fail(function (data) {
                    messageApi.error(data.responseJSON.detail, CNF.messageDuration);
                })
        }
        getAppInfo();
    }, []);

    // Chat messages
    const { setMessages, abort, messages, isRequesting } = useXChat({});

    /**
     * 获取结果-大模型
     * @param {*} step 
     * @returns 
     */
    const getResultLLM = async (step) => {
        const model = step.model;
        const input = step.input;
        let currentMessages = [];
        if (input?.system_prompt) {
            currentMessages.push({
                role: 'system',
                content: JSON.stringify(input.system_prompt),
            });
        }
        currentMessages.push({
            role: 'user',
            content: JSON.stringify(input.user_prompt),
        });

        return new Promise((resolve, reject) => {
            // 用于存储流式接收到的所有数据块
            let result = '';

            $.ajax({
                url: CNF.onaiApi + 'completions',
                type: 'POST',
                headers: AddRequestHeaders(),
                contentType: 'application/json',
                data: JSON.stringify({
                    project_code: CNF.projectCode.toLocaleLowerCase(),  // 项目代码
                    model: model.name,
                    version_id: model.value,
                    stream: 0,
                    messages: currentMessages,
                    temperature: model.temperature,
                    top_p: model.top_p,
                    max_tokens: model.max_tokens,
                }),
                dataType: 'text', // 关键：必须以文本接收
                processData: false,

                // 核心：监听进度事件以读取流
                xhrFields: {
                    onprogress: function (e) {
                        const responseText = e.target.responseText;
                        // 按行分割
                        const lines = responseText.split('\n');

                        lines.forEach(function (line) {
                            // SSE 数据通常以 "data: " 开头
                            if (line.startsWith('data:')) {
                                var jsonStr = line.substring(5); // 去掉 "data:"

                                // 尝试解析 JSON
                                try {
                                    var jsonData = JSON.parse(jsonStr);
                                    result = jsonData.result;

                                } catch (err) {
                                    console.error("JSON 解析错误:", err);
                                }
                            }
                        });
                    }
                },

                // 当流传输成功结束时触发
                success: function () {
                    resolve(result);
                },

                // 当发生错误时触发
                error: function (xhr, textStatus, errorThrown) {
                    // 注意：SSE 连接断开有时也会触发 error，视浏览器实现而定
                    // 这里我们依然返回已收集的数据，或者根据需求 reject
                    console.error('请求出错:', textStatus);
                    reject('请求火爆请稍后再试！');
                }
            });
        });
    };

    /**
     * 获取结果-MCP
     * @param {*} step 
     * @returns 
     */
    const getResultMCP = async (step) => {
        const input = step.input;
        var params = {
            tool_name: input.toolName,  // 工具名称
        };
        const result = {};
        if (input.parameters && Object.keys(input.parameters).length > 0) {
            for (const key in input.parameters) {
                let content = '';
                // 确保遍历的是对象自身的属性（非原型链上的）
                if (input.parameters.hasOwnProperty(key)) {
                    content = input.parameters[key].default !== undefined ? input.parameters[key].default : '';
                }
                result[key] = content;
            }
        }
        params = {
            ...params,
            arguments: result
        }
        return new Promise((resolve, reject) => {
            // 调用工具

            $.ajax({
                url: `${CNF.xmcpApi}tools`,
                headers: AddRequestHeaders(),
                type: 'POST',
                dataType: 'JSON',
                data: JSON.stringify(params)
            }).done((data) => {
                if (data.res === 0) {
                    resolve(data);
                } else {
                    console.log(CNF.msg);
                    reject(CNF.msg);
                }
            }).fail(() => {
                console.log('MCP服务异常');
                reject('MCP服务异常');
            });
        });
    };

    /**
     * 获取结果-API
     * @param {*} step 
     * @returns 
     */
    const getResultAPI = async (step) => {
        const input = step.input;
        var params = {};
        if (input.params) {
            for (let i = 0; i < input.params.length; i++) {
                const item = input.params[i];
                const key = item.name;
                params[key] = item.value;
            }
        }

        return new Promise((resolve, reject) => {

            if (input.type && input.type !== 'GET') {
                // 非GET请求
                $.ajax({
                    url: `${input.url}`,
                    headers: AddRequestHeaders(),
                    type: 'POST',
                    dataType: 'JSON',
                    data: JSON.stringify(params)
                }).done(function (data) {
                    if (data.res === 0) {
                        if (input.response?.filed) {
                            resolve(GetObjValueByPath(data, input.response?.filed));
                        } else {
                            resolve(data);
                        }
                    } else {
                        reject(CNF.msg);
                    }
                }).fail(function (data) {
                    reject(data.responseJSON.detail);
                });
            } else {
                $.ajax({
                    url: `${input.url}${Object.keys(params).length === 0 ? '' : UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    type: 'GET',
                }).done((data) => {
                    if (data.res === 0) {
                        if (input.response?.field) {
                            resolve(GetObjValueByPath(data, input.response?.field));
                        } else {
                            resolve(data);
                        }
                    } else {
                        reject(CNF.msg);
                    }
                }).fail((data) => {
                    reject(data.responseText);
                })
            }
        });
    };

    /**
     * 获取节点输入变量数据
     * 字段如果包含，形如''0/x/x'，即为引用其它节点的变量，则需要转换为对应的内容
     * 第1个数字（如：0）为节点在数组中的位置，之后的字符（如：/x/x）为节点内容路径
     * @param {*} nodeList 
     * @param {*} node 
     */
    const getNodeVarData = (nodeList, node, key = 'input') => {
        const currentNode = node;
        // 获取数组的变量内容
        const getArrVarValue = (arr) => {
            let newArr = arr;
            for (let i = 0; i < arr.length; i++) {
                let arrItem = arr[i];
                if (typeof arrItem === 'string' && arrItem) {
                    // 更新后的值
                    let newValue = '';
                    // 基于分割字符串拆分值
                    let splitArr = arrItem.split(CNF.APP_CONFIG_SPLIT);
                    for (let j = 0; j < splitArr.length; j++) {
                        let splitItem = splitArr[j];
                        let parts = splitItem.split('/');
                        // 判断是否为变量引用
                        if (parts.length > 1 && /^([0-9]{1,})$/.test(parts[0])) {
                            // 获取目标节点
                            let targetNode = nodeList[parts[0]]
                            // 引用的变量
                            const content = GetObjValueByPath(targetNode, parts.slice(1).join('/'));
                            newValue += (typeof content === 'string' ? content : JSON.stringify(content));
                        } else {
                            newValue += splitItem;
                        }
                    }
                    newArr[i] = newValue;
                } else if (Array.isArray(arrItem) && arrItem.length > 0) {
                    newArr[i] = getArrVarValue(arrItem);
                } else if (arrItem && typeof arrItem === 'object' && Object.keys(arrItem).length > 0) {
                    newArr[i] = getObjVarValue(arrItem);
                } else {
                    continue;
                }
            }
            return newArr;
        }

        // 获取对象的变量内容
        const getObjVarValue = (obj) => {
            let newObj = obj;
            // 获取输入对象key数组
            let objKeyArr = Object.keys(obj);
            for (let i = 0; i < objKeyArr.length; i++) {
                // 获取输入对象key对应的值
                let key = objKeyArr[i];
                let value = obj[key];
                // 如果是字符串则解析变量
                if (typeof value === 'string') {
                    // 更新后的值
                    let newValue = '';
                    // 基于分割字符串拆分值
                    let splitArr = value?.split(CNF.APP_CONFIG_SPLIT);
                    for (let j = 0; j < splitArr.length; j++) {
                        let splitItem = splitArr[j];
                        let parts = splitItem.split('/');
                        // 判断是否为变量引用
                        if (parts.length > 1 && /^([0-9]{1,})$/.test(parts[0])) {
                            // 获取目标节点
                            let targetNode = nodeList[parts[0]]
                            // 引用的变量
                            const content = GetObjValueByPath(targetNode, parts.slice(1).join('/'));
                            newValue += (typeof content === 'string' ? content : JSON.stringify(content));
                        } else {
                            newValue += splitItem;
                        }
                    }
                    newObj[key] = newValue;
                } else if (Array.isArray(value) && value.length > 0) {
                    newObj[key] = getArrVarValue(value);
                } else if (value && typeof value === 'object' && Object.keys(value).length > 0) {
                    newObj[key] = getObjVarValue(value);
                } else {
                    continue;
                }
            }
            return newObj;
        }

        if (node[key]) {
            // 获取输入对象key数组
            currentNode[key] = getObjVarValue(node[key]);
        }

        return currentNode;
    }

    /**
     * 获取运行状态
     * @param {*} status 
     * @returns 
     */
    const getRunStatus = (status) => {
        switch (status) {
            case CNF.runStatus.RUNNING:
                return <SyncOutlined spin style={{ color: colorPrimary }} />
            case CNF.runStatus.STOP:
                return <StopIcon style={{ color: colorTextBase, fontSize: fontSizeLG, }} />
            case CNF.runStatus.SUCCESS:
                return <CheckCircleOutlined style={{ color: colorSuccessActive }} />
            case CNF.runStatus.ERROR:
                return <CloseCircleOutlined style={{ color: colorErrorActive }} />
            default:
                return ''
        }
    }

    /**
     * 增加一次调用
     */
    const addOneCall = () => {
        $.ajax({
            url: `${CNF.api}app/infos/${appInfo?.key}`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                'add_run_count': 1,
                'description': '运行应用',
            })
        }).done(function (data) {
            if (data.res === 0) {
                //
            } else {
                // 操作失败
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            // 接口异常
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    }

    /**
     * 提交
     * @param {*} content 
     */
    const onSubmit = (content) => {
        // 开始运行，更新运行状态
        setRunStatus(true);
        // 重置运行步骤列表
        const runStepList = [];
        // 将最新的请求添加至末尾
        let newMessages = [...messages];
        if (content) {
            newMessages = [...messages, {
                id: messages.length + 1,
                message: {
                    role: 'user',
                    content: content,
                },
                status: CNF.runStatus.SUCCESS,
            }]
        }
        setMessages(newMessages);

        // 深拷贝原始节点配置，避免污染 appNodeData
        const runStep = JSON.parse(JSON.stringify(appNodeData[0]));
        // 将内容赋值给开始节点的 query 字段
        runStep.input.sys.query = content;
        // 开始步骤加入到运行步骤列表
        runStepList.push(runStep);

        // 开始运行步骤
        onRunStep(newMessages, runStepList);
    }

    /**
     * 运行步骤
     * @param {*} newMessages 
     * @param {*} runStepList
     * @returns 
     */
    const onRunStep = async (newMessages, runStepList) => {
        // 开始时间
        const start = performance.now();
        // 判断步骤是否已执行完
        if (runStepList.length === appNodeData.length) {
            // 输出初始化配置
            setMessages([...newMessages, {
                id: newMessages.length + 1,
                message: {
                    role: 'assistant',
                    content: runStepList,
                },
                status: CNF.runStatus.SUCCESS,
            }]);
            return;
        }

        // 获取下一运行步骤的原始定义（深拷贝）
        const originalNextStep = appNodeData[runStepList.length];
        let nextRunStep = JSON.parse(JSON.stringify(originalNextStep));

        // 填充变量（此时 nextRunStep 是独立副本，不会污染原始定义）
        nextRunStep = getNodeVarData(runStepList, nextRunStep);
        // 加入运行步骤列表
        const newRunStepList = [...runStepList, nextRunStep];

        // 输出初始化配置
        setMessages([...newMessages, {
            id: newMessages.length + 1,
            message: {
                role: 'assistant',
                content: newRunStepList,
            },
            status: CNF.runStatus.RUNNING,
        }]);

        // 执行步骤获取返回数据
        if (nextRunStep.key === CNF.nodeConfig.llm.key) {
            nextRunStep.output.result = await getResultLLM(nextRunStep);
        } else if (nextRunStep.key === CNF.nodeConfig.mcp.key) {
            nextRunStep.output.result = await getResultMCP(nextRunStep);
        } else if (nextRunStep.key === CNF.nodeConfig.api.key) {
            nextRunStep.output.result = await getResultAPI(nextRunStep);
        } else if (nextRunStep.key === CNF.nodeConfig.end.key) {
            nextRunStep.output.result = getNodeVarData(newRunStepList, nextRunStep, 'output').output?.result;
        }

        // 更新当前运行步骤
        newRunStepList[newRunStepList.length - 1] = nextRunStep;

        // 更新输出
        setMessages([...newMessages, {
            id: newMessages.length + 1,
            message: {
                role: 'assistant',
                content: newRunStepList,
            },
            status: CNF.runStatus.RUNNING,
        }]);

        // 结束时间
        const end = performance.now();

        // 更新输出
        setMessages([...newMessages, {
            id: newMessages.length + 1,
            message: {
                role: 'assistant',
                content: (newRunStepList.at(-1).runTime = (end - start).toFixed(0), newRunStepList),
            },
            status: CNF.runStatus.RUNNING,
        }]);

        // 执行下一步（传入深拷贝后的步骤列表）
        await onRunStep(newMessages, newRunStepList);
    }

    return <>
        {/* --start-- 路径栏 */}
        <div style={{
            height: CNF.contentHeaderHeight,
            borderBottom: 'solid 1px',
            borderBottomColor: colorBgSolid,
            padding: `0 ${CNF.basePadding}px`,
        }}>
            {contextHolder}
            <Flex>
                <div style={{ width: '60%', height: CNF.contentHeaderHeight, display: 'flex', alignItems: 'center', }}>
                    <Button
                        color='default'
                        variant='link'
                        style={{ fontSize: fontSizeLG, padding: 0 }}
                        onClick={() => {
                            // 返回上一级
                            props.setUri(props.pUri);
                        }}
                    >{props.menuName}</Button>
                    &nbsp;
                    <Text>/</Text>
                    &nbsp;
                    <Text style={{ fontSize: fontSizeLG, }}><strong>{appInfo?.app_name}</strong></Text>
                </div>
                <div style={{ width: '40%', height: CNF.contentHeaderHeight, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', }}>
                    <Space>
                        <Button
                            color='default'
                            variant='text'
                            size='small'
                            icon={<ContainerOutlined />}
                            onClick={() => {
                            }}
                        >使用指南
                        </Button>
                        <Button
                            color='default'
                            variant='text'
                            size='small'
                            icon={<SettingOutlined />}
                            onClick={() => {
                            }}
                        >设置
                        </Button>
                    </Space>
                </div>
            </Flex>
        </div>
        {/* --end-- 路径栏 */}

        <Flex>
            {/* --start-- 应用运行区 */}
            <div style={{
                height: winHeight - CNF.menuHeight - CNF.contentHeaderHeight - 9,
                width: '84%',
                borderRight: `1px solid ${colorBgSolid}`,
            }}>
                <Flex vertical={true}>
                    {/* --start-- 快捷操作 */}
                    <div style={{ height: 48, display: 'flex', justifyContent: 'flex-end', padding: CNF.basePadding }}>
                        <Space>
                            <Button
                                color='default'
                                variant='text'
                                size='small'
                                onClick={() => {
                                }}
                            ><Badge dot color={colorPrimary}><SettingOutlined /></Badge>
                            </Button>
                            <Button
                                color='default'
                                variant='text'
                                size='small'
                                onClick={() => {
                                    setMessages([]);
                                }}
                            ><ClearOutlined />
                            </Button>
                        </Space>
                    </div>
                    {/* --end-- 快捷操作 */}

                    {/* --start-- 内容输出 */}
                    <div
                        ref={contentRef}
                        style={{
                            height: winHeight - CNF.menuHeight - CNF.contentHeaderHeight - 200,
                            scrollbarColor: '#d9d9d9 transparent',
                            scrollbarWidth: 'thin',
                            overflowY: 'auto',
                            padding: '0 20%',
                        }}>
                        {
                            messages.length > 0 ? <>
                                {
                                    messages.map(({ id, message, status }, index) => {
                                        let isLocal = message?.role === 'user' ? true : false;
                                        // 打印用户输入
                                        if (isLocal) {
                                            return <Bubble
                                                key={id}
                                                style={{
                                                    marginBottom: 10,
                                                    marginRight: 10,
                                                    marginTop: index > 0 ? 20 : 0,  // 后续的提示项，添加顶部间距
                                                }}
                                                styles={{
                                                    content: {
                                                        background: colorPrimary,
                                                    }
                                                }}
                                                variant='filled'
                                                placement={'end'}
                                                avatar={(cookie.load(CNF.cookies.keyAvatarUrl) ? <Avatar src={CNF.ossApi + cookie.load(CNF.cookies.keyAvatarUrl)} preview='false' /> : <Avatar style={{ backgroundColor: colorPrimary }}>{cookie.load(CNF.cookies.keyId) ? cookie.load(CNF.cookies.keyId).substr(0, 1).toUpperCase() : 'U'}</Avatar>)}
                                                typing={false}
                                                content={message?.content}
                                                contentRender={(content) => {
                                                    return <Text style={{ color: '#fff' }}>{content}</Text>
                                                }}
                                            />
                                        }

                                        // 打印系统返回
                                        return (
                                            <div key={id}>
                                                {/* 运行状态 */}
                                                <div>
                                                    <Space>
                                                        {
                                                            getRunStatus(status)
                                                        }
                                                        <Text>{status}</Text>
                                                    </Space>
                                                </div>
                                                {/* 运行步骤 */}
                                                <div style={{ background: colorStepBg, marginTop: 12, padding: '3px 0', borderRadius: 8, }}>
                                                    {
                                                        message?.content.map((node, index) => {
                                                            return <StepEntity
                                                                key={index}
                                                                isDarkMode={props.isDarkMode}
                                                                contentRef={contentRef}
                                                                stepIsRunning={(index + 1) === message.content.length && status === CNF.runStatus.RUNNING}
                                                                node={node}
                                                                appInfo={appInfo}
                                                                setRunStatus={setRunStatus}
                                                            />
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </>
                                :
                                <Flex vertical style={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    {/* 应用图标 */}
                                    <Paragraph><Avatar shape='square' src={appInfo?.app_icon} size={64} style={{ border: `1px solid ${colorBgSolid}` }} /></Paragraph>
                                    {/* 应用标题 */}
                                    <Title level={5} style={{ color: colorTextBase, margin: '10px 0' }}>{appInfo?.app_name}</Title>
                                    {/* 默认提示 */}
                                    <Prompts
                                        vertical
                                        styles={{
                                            item: {
                                                width: '100%',
                                                padding: '8px',
                                                background: colorPrimaryBg,
                                                border: 0,
                                            },
                                        }}
                                        title={<Text style={{ color: colorBasePlaceholder, fontSize: fontSizeSM }}>{appInfo?.prompt_title}</Text>}
                                        items={appInfo?.prompt_examples ? appInfo?.prompt_examples.split('|').map((item, index) => ({
                                            key: index + 1,
                                            icon: <CaretRightOutlined style={{ color: colorPrimary }} />,
                                            description: item,
                                        })) : []}
                                        onItemClick={(info) => {
                                            onSubmit(info.data.description);
                                            addOneCall();
                                        }}
                                    />
                                    {/* 默认提示 */}
                                </Flex>
                        }
                    </div>
                    {/* --end-- 内容输出 */}

                    {/* --start-- 内容输入 */}
                    <div style={{ height: 100, padding: '0 20%', display: 'flex', marginTop: 10, justifyContent: 'center', alignItems: 'center', }}>
                        {
                            // 不需要输入的应用
                            appInfo?.is_input === 0 ? <Tooltip title={runStatus ? '运行中···' : '点击运行'}><Button
                                color='primary'
                                shape='circle'
                                variant={props.isDarkMode ? 'filled' : 'solid'}
                                onClick={() => {
                                    if (runStatus) return; // 运行中禁止取消
                                    onSubmit('');
                                    addOneCall();
                                    setRunStatus(true);
                                }}
                                icon={runStatus ? <SyncOutlined spin /> : <ArrowUpOutlined />}
                            /></Tooltip> : <Sender
                                // 根据运行状态是否为“执行中”判断
                                loading={runStatus}
                                readOnly={runStatus}
                                value={content}
                                autoSize={{ minRows: 3, maxRows: 3 }}
                                style={{ borderColor: colorBgSolid }}
                                suffix={(_, info) => {
                                    const { SendButton, LoadingButton } = info.components;

                                    if (runStatus) {
                                        return (
                                            <Tooltip title='点击取消'>
                                                <LoadingButton />
                                            </Tooltip>
                                        );
                                    }

                                    let node = <SendButton style={{ border: 'none' }} />;

                                    if (!runStatus) {
                                        node = (
                                            <Tooltip title={content ? 'Send \u21B5' : '请输入一些内容'}>{node}</Tooltip>
                                        );
                                    }

                                    return node;
                                }}
                                onChange={nextContent => {
                                    // 输入内容改变
                                    setContent(nextContent)
                                }}
                                onSubmit={(nextContent) => {
                                    // 发送指令请求
                                    onSubmit(nextContent);
                                    setContent('');
                                    addOneCall();
                                }}
                                onCancel={() => {
                                    // 取消指令请求
                                    // setMessages([...messages.slice(0, -1), { ...messages[messages.length - 1], status: CNF.runStatus.STOP }]);
                                    setMessages((messages.at(-1).status = CNF.runStatus.STOP, messages))
                                    setRunStatus(false);
                                    try {
                                        abort();
                                    } catch {
                                        //
                                    }
                                }}
                            />
                        }

                    </div>
                    {/* --end-- 内容输入 */}

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '8px 0' }}>
                        <Text style={{ color: colorBasePlaceholder, fontSize: fontSizeSM, }}>内容由AI生成，仅供参考</Text>
                    </div>
                </Flex>
            </div>
            {/* --end-- 应用运行区 */}

            {/* --start-- 应用展示区 */}
            <div style={{
                height: winHeight - CNF.menuHeight - CNF.contentHeaderHeight - 9,
                width: '16%',
                padding: CNF.basePadding,
            }}>
                {/* 应用图标 */}
                <Paragraph style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}><Avatar shape='square' src={appInfo?.app_icon} size={48} style={{ border: `1px solid ${colorBgSolid}` }} /></Paragraph>
                {/* 应用标题 */}
                <Title level={4} style={{ display: 'flex', justifyContent: 'center', color: colorTextBase, margin: '10px 0' }}>{appInfo?.app_name}</Title>
                {/* 应用描述 */}
                <Paragraph style={{ color: colorBasePlaceholder, fontSize: fontSizeSM }}>{appInfo?.app_description}</Paragraph>
                {/* 应用使用 */}
                <Paragraph style={{ color: colorTextBase, fontSize: fontSizeLG, margin: 0 }}><Statistic suffix={appInfo?.run_count >= 10000 ? '万' : ''} value={appInfo?.run_count >= 10000 ? (appInfo?.run_count / 10000).toFixed(CNF.DPL) : appInfo?.run_count} /></Paragraph>
                <Paragraph style={{ color: colorBasePlaceholder, fontSize: fontSizeSM }}>使用次数</Paragraph>
            </div>
            {/* --end-- 应用展示区 */}
        </Flex>
    </>
}

export default AppRun;